/* eslint quotes:0 */
'use strict';

// Utils
function string2number(input) {
  let inp = input;
  let bits = [];

  inp += '';
  inp = inp.replace(/\s/g, '');
  inp = inp.replace(/\./g, ',');
  bits = inp.split(',');
  bits[bits.length - 2] += '.';
  inp = bits.join('');
  return inp;
}

// set a default value to an input so if the input is $dirty it still goes back to that
// $filter('defaultValue')(this.value, null);
function defaultValue() {
  return (input, value) => {
    return !input ? value : input;
  };
}

// round number without breaking the decimals
// returns a number
// {{ 15.254464 | round:2 }}
function round() {
  return (input, decimals = 2) => (-1 * Math.round(string2number(input) * 100) / 100).toFixed(decimals) * -1;
}

// round number without breaking the decimals
// returns a string
// {{ 15.254464 | round:2 }}
function roundString() {
  return (input, decimals = 2) => (Math.round(string2number(input) * 100) / 100).toFixed(decimals);
}

// number to crowns
// {{ 1415.25 | crowns }}
function crowns($filter) {
  return (input, currency = true, decimals = 2) => {
    let inp = input;
    inp = $filter('round')(inp, decimals);

    if (isNaN(inp) || inp === 0) {
      inp = '0,00';
    } else {
      inp = inp.toFixed(2).replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return currency ? `kr ${inp}` : inp;
  };
}

// anything to number
// {{ '1 415,25' | numberify }}
function numberify($filter) {
  return (input) => {
    return $filter('round')(string2number(input));
  };
}

// change iso date to Norwegian date format
// {{ 1982-03-12 | dateFormat }}
// {{ 1982-03-12 12:52 | dateFormat:true }}
function dateFormat() {
  return (input, time = false) => {
    if (input !== null && input !== '') {
      if (moment(input, 'YYYY-MM-DD').isValid()) {
        if (time) {
          return moment(input, 'YYYY-MM-DD HH:mm').format('DD.MM.YY HH:mm');
        } else {
          return moment(input, 'YYYY-MM-DD').format('DD.MM.YY');
        }
      } else {
        return input;
      }
    } else {
      return input;
    }
  };
}

// format organisation number
// {{ 996718859 | organisationNumberFormat }}
function organisationNumberFormat() {
  return (input) => {
    return (input + '').replace(/(.{3})/, "$1 ").replace(/(.{7})/, "$1 ");
  };
}

// format account number
// {{ 97501101412 | accountNumberFormat }}
function accountNumberFormat() {
  return (input) => {
    return input ? (input + '').replace(/(.{4})/, "$1.").replace(/(.{7})/, "$1.") : input;
  };
}

// capitalize string
// {{ "lorem ipsum" | capitalize }}
function capitalize() {
  return (input) => {
    if (input && input.length) {
      let output = input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
      return output.split(' ').join(' ');
    } else {
      return input;
    }
  };
}

function urlParser() {
  return (input, index) => {
    if (input && input.length) {
      let output = input;

      if (output.charAt(0) === '/') {
        output = output.substr(1);
      }

      return output.split('/')[index];
    }
  };
}

function parseLinkHeader() {
  return (header) => {
    let linkexp = /<[^>]*>\s*(\s*;\s*[^\(\)<>@,;:"\/\[\]\?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*")))*(,|$)/g;
    let paramexp = /[^\(\)<>@,;:"\/\[\]\?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*"))/g;
    let matches = header.match(linkexp);
    let rels = {};

    for (let i = 0; i < matches.length; i++) {
      let split = matches[i].split('>');
      let href = split[0].substring(1);
      let ps = split[1];
      let link = {};
      link.href = href;
      let s = ps.match(paramexp);

      for (let j = 0; j < s.length; j++) {
        let p = s[j];
        let paramsplit = p.split('=');
        let name = paramsplit[0];
        let value = paramsplit[1];
        link[name] = value.charAt(0) === '"' && value.charAt(value.length - 1) === '"' ? value.substring(1, value.length - 1) : value;
      }

      if (link.rel !== typeof 'undefined') {
        rels[link.rel] = link;
      }
    }

    return rels;
  };
}

// Truncate text by words
// {{ "Lorem ipsum dolor sit amet..." | truncate:5 }}
function truncate() {
  return (input, words) => {
    let inp = input;

    if (isNaN(words)) {
      return inp;
    }

    if (words <= 0) {
      return '';
    }

    if (inp) {
      let inputWords = input.split(/\s+/);

      if (inputWords.length > words) {
        inp = inputWords.slice(0, words).join(' ') + '…';
      }
    }

    return inp;
  };
}

// Sanitize html
// {{ "<b>Lorem</b> ipsum" | html }}
function html($sce) {
  return (input) => {
    if (input && input.length) {
      return $sce.trustAsHtml(input);
    }
  };
}

// Return the correct Norwegian name for a document
function documentName() {
  const i18n = {
    Invoice: 'Regning',
    '1Dunning': '1. Purring',
    '2Dunning': '2. Purring',
    '3Dunning': '3. Purring',
    '4Dunning': '4. Purring',
    debtCollectionNotice: 'Inkassovarsel',
    deptCollectionNotice: 'Inkassovarsel',
    debtCollection: 'Inkasso'
  };

  return (input) => {
    if (input && input in i18n) {
      return i18n[input];
    } else {
      return input;
    }
  };
}

// Check if a given object is empty
// {{ {} | isEmptyObject }}
function isEmptyObject() {
  return (obj) => {
    return angular.equals({}, obj);
  };
}

crowns.$inject = ['$filter'];
html.$inject = ['$sce'];

angular
  .module('sr.filters', [])
  .filter('defaultValue', defaultValue)
  .filter('round', round)
  .filter('roundString', roundString)
  .filter('crowns', crowns)
  .filter('numberify', numberify)
  .filter('dateFormat', dateFormat)
  .filter('organisationNumberFormat', organisationNumberFormat)
  .filter('accountNumberFormat', accountNumberFormat)
  .filter('capitalize', capitalize)
  .filter('urlParser', urlParser)
  .filter('parseLinkHeader', parseLinkHeader)
  .filter('truncate', truncate)
  .filter('html', html)
  .filter('documentName', documentName)
  .filter('isEmptyObject', isEmptyObject);
